
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.638 14.933a.857.857 0 01-.28-.19l-4.1-4.115-.164-.249A.795.795 0 015 10a.89.89 0 01.094-.391l.165-.237 4.1-4.114a.856.856 0 011.225 0 .87.87 0 010 1.233L7.969 9.122h6.16c.482 0 .871.392.871.878a.873.873 0 01-.872.877h-6.16l2.615 2.632a.87.87 0 010 1.233.856.856 0 01-.945.19z"}})])
          )
        }
      }
    